{
    "translation": {
        "errors": {
            "password_requirements": "Dein Passwort muss aus mindestens 9 Zeichen bestehen, darunter eine Zahl, Großbuchstaben, Kleinbuchstaben und Sonderzeichen.",
            "password_confirm": "Passwort stimmt nicht überein"
        },

        "generic": {
            "fetching": "Lade Daten...",
            "submit": "Absenden",
            "page_not_found": "Seite wurde nicht gefunden",
            "support": "Support",
            "error_title": "Entschuldigung, irgendetwas ist schiefgelaufen.",
            "error_text": "Der Fehler '{{ errorMessage }}' ist aufgetreten. Bitte kontaktiere den Support für Hilfe.",
            "unknown_error_text": "Ein unbekannter Fehler ist aufgetreten. Bitte kontaktiere den Support für Hilfe."
        },

        "email_activation": {
            "title": "E-Mail Aktivierung",
            "success_title": "Willkommen bei Anio!",
            "success_text": "Die E-Mail wurde erfolgreich bestätigt und der Account wurde aktiviert."
        },

        "password_reset": {
            "title": "Passwort zurücksetzen",
            "new_password": "Neues Passwort",
            "new_password_confirm": "Neues Passwort bestätigen",
            "success_title": "Das Passwort wurde erfolgreich zurückgesetzt!"
        },

        "friend_code": {
            "title": "Freund hinzufügen",
            "description": "Du wurdest eingeladen, einen Freund in der Anio-App hinzuzufügen.<br />Gib dafür einfach den folgenden Code im Freunde-Menü der Anio-App ein:",
            "copy_code": "Code kopieren",
            "code_copied": "Code in die Zwischenablage kopiert!"
        }
    }
}
